module.exports = __webpack_public_path__ + "img/boende.9dc11a64.jpg";